export default __webpack_public_path__ + "static/media/hero-img.4a221ab2.svg";